import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "error", "checkbox", "submit", "othersCheckbox", "othersTextField", "reasons"]

  submit(event) {
    const isChecked = this.checkboxTargets.some((checkbox) => checkbox.checked)

    if (!isChecked && !this.othersCheckboxTarget.checked) {
      event.preventDefault()
      this.showError()
      this.submitTarget.disabled = true
    } else {
      this.clearError()
      if (this.othersCheckboxTarget.checked) {
        this.othersTextFieldTarget.value = `Others: ${this.othersTextFieldTarget.value}`
      }
    }
  }

  change() {
    const hasSelection =
      this.checkboxTargets.some((checkbox) => checkbox.checked) || this.othersCheckboxTarget.checked

    if (hasSelection) {
      this.clearError()
    }
    this.submitTarget.disabled = !hasSelection

    if (this.othersCheckboxTarget.checked) {
      this.othersTextFieldTarget.disabled = false
    } else {
      this.othersTextFieldTarget.disabled = true
      this.othersTextFieldTarget.value = ""
    }
  }

  showError() {
    this.errorTarget.classList.remove("hidden")
    if (this.hasReasonsTarget) {
      this.reasonsTarget.setAttribute("aria-invalid", "true")
      this.reasonsTarget.setAttribute("aria-describedby", this.errorTarget.id)
    }
    this.errorTarget.focus()
  }

  clearError() {
    this.errorTarget.classList.add("hidden")
    if (this.hasReasonsTarget) {
      this.reasonsTarget.removeAttribute("aria-invalid")
      this.reasonsTarget.removeAttribute("aria-describedby")
    }
  }
}
